// import useNavigator from "@saleor/hooks/useNavigator";
// import { RouteComponentProps } from "react-router-dom";
import useNotifier from "@saleor/hooks/useNotifier";
import useUser from "@saleor/hooks/useUser";
import { commonMessages } from "@saleor/intl";
import Cookies from "js-cookie";
import React, { useState } from "react";
import { useIntl } from "react-intl";
// import { parse as parseQs } from "qs";
import { Navigate } from "react-router-dom";

import OtpPage, { OTPVerifyFormData } from "../components/OTP/OtpPage";
import { OTPGenerateMutation } from "../mutations";
import { OTPVerifyMutation } from "../mutations";
import { OTPGenerate } from "../types/OTPGenerate";
import { OTPVerify } from "../types/OTPVerify";
// import { userBusinessDetailsPath } from "../urls";
import Validate from "./../controllers/CustomValidation";
// import { StoreContext } from "./../store/StoreContext";
// import { TypedStaffMemberDetailsQuery } from "@saleor/staff/queries";
interface OtpVerifyProps {
  id: string;
}

const OtpVerify: React.FC<OtpVerifyProps> = props => {
  const notify = useNotifier();
  const intl = useIntl();
  const { currentUser, currentUserPass } = Cookies.get();
  const { login } = useUser();
  // console.log(currentUser)
  // const { otpGenerate, user } = state;
  // console.log(otpGenerate);
  // const staff = staffMemberDetailsUrl(props.id);
  // console.log(staff);
  // const navigate = useNavigator();
  const [validations, setValidation] = useState({
    err: {},
    err_msg: []
  });

  const handleVerify = (data: OTPVerify) => data;
  const handleOTPGenerate = (data: OTPGenerate) => data;
  const [otp] = OTPGenerateMutation({
    onCompleted: handleOTPGenerate
  });
  const resendOTP = async () => {
    await otp({
      variables: {
        input: {
          user: JSON.parse(currentUser).id
        }
      }
    }).then(result => {
      // console.log(result);
      if (result) {
        notify({
          status: "success",
          text: intl.formatMessage(commonMessages.otpResend)
        });
      }
    });
    // .then(error => {
    //   // console.log(error);
    // });
  };
  return currentUser && JSON.parse(currentUser).id ? (
    <OTPVerifyMutation onCompleted={handleVerify}>
      {OTPVerify => {
        const handleSubmit = async (data: OTPVerifyFormData) => {
          const initValidations = {
            pin: { required: true, usename: "Pin" }
          };
          const {
            validation_errors,
            validation_has_error,
            validation_message
          } = Validate(initValidations, data);
          if (validation_has_error) {
            const timer = setTimeout(() => {
              // console.log(validation_errors);
              // console.log(validation_message);
              setValidation({
                err: validation_errors,
                err_msg: validation_message
              });
              return false;
            }, 1500);
            return () => clearTimeout(timer);
          }
          // console.log(JSON.parse(currentUser).id);
          // console.log(data);
          if (currentUser) {
            const verify_result = await OTPVerify({
              variables: {
                input: {
                  pin: data.pin,
                  user: props.id
                }
              }
            });
            // console.log('verify_result');
            // console.log(verify_result);

            const {
              // token,
              // csrfToken,
              // user,
              errors
            } = verify_result.data.otpVerify;

            // console.log('verify_result');
            // console.log(verify_result);
            // console.log(token);
            if (errors.length) {
              //   console.log(errors);
              setValidation({
                err: {},
                err_msg: errors
              });
              return false;
            }
            login(JSON.parse(currentUser).email, currentUserPass);
            Cookies.remove("currentUser");
            Cookies.remove("currentUserPass");
            // navigate(userBusinessDetailsPath);
          }
        };
        return (
          <OtpPage
            handleResendOTP={resendOTP}
            validations={validations}
            onSubmit={handleSubmit}
          />
        );
      }}
    </OTPVerifyMutation>
  ) : (
    <Navigate to="/signup" replace />
  );
};
// OtpVerify.displayName = "OtpVerify";
export default OtpVerify;
